export default __webpack_public_path__ + "static/media/project_thumbnail_mcm.ef3d8650.png";